export const COLOR_MODE_STORAGE_KEY = 'dcs-color-mode';

export const resolveColorMode = (mode, systemMode) => {
  if (mode === 'system' || mode == null) {
    return systemMode ?? 'light';
  }

  return mode;
};
